import { Link } from 'react-router-dom'
import { COMPETITORS } from '../data/competitors.js'
import {
  OGL_LICENCE_NAME,
  OGL_LICENCE_URL,
  PRICE_PAID_ATTRIBUTION_LEAD,
} from '../utils/pricePaidAttribution.js'

// A small, stable set of major published cities used to seed crawl discovery of
// the programmatic per-area pages from the site-wide footer. These cities are
// permanent fixtures of the published set, so the links won't rot; each page in
// turn interlinks to its neighbours, so crawlers can reach the long tail.
const POPULAR_AREAS = [
  { slug: 'manchester', name: 'Manchester' },
  { slug: 'birmingham', name: 'Birmingham' },
  { slug: 'leeds', name: 'Leeds' },
  { slug: 'liverpool', name: 'Liverpool' },
  { slug: 'bristol', name: 'Bristol' },
  { slug: 'sheffield', name: 'Sheffield' },
  { slug: 'nottingham', name: 'Nottingham' },
  { slug: 'leicester', name: 'Leicester' },
]

const Footer = () => {
  return (
    <footer className="footer">
      <strong>KEYZEE</strong>
      <small>
        Private listings across the UK &bull; Direct buyer-seller introductions &bull; Free to list &bull; Free to sell &bull; Always{' '}

      </small>

      <div className="footer__links">
        <nav className="footer__col" aria-label="Sell your home">
          <h4 className="footer__col-title">Sell your home</h4>
          <Link to="/sell-without-an-agent/">Sell without an agent</Link>
          <Link to="/house-valuation/">Free house valuation</Link>
          <Link to="/also-list/">List alongside Rightmove</Link>
          <Link to="/compare-estate-agents/">Compare estate agents</Link>
        </nav>

        <nav className="footer__col" aria-label="Compare Keyzee">
          <h4 className="footer__col-title">Compare</h4>
          {COMPETITORS.map((competitor) => (
            <Link key={competitor.slug} to={`/${competitor.slug}-alternative/`}>
              {competitor.name} alternative
            </Link>
          ))}
        </nav>

        <nav className="footer__col" aria-label="Explore Keyzee">
          <h4 className="footer__col-title">Explore</h4>
          <Link to="/listings">Browse listings</Link>
          <Link to="/house-prices/">UK house prices by area</Link>
          <Link to="/blog/">Guides for home sellers</Link>
        </nav>

        <nav className="footer__col" aria-label="Sell in popular areas">
          <h4 className="footer__col-title">Sell in your area</h4>
          {POPULAR_AREAS.map((area) => (
            <Link key={area.slug} to={`/sell-without-an-agent/${area.slug}/`}>
              Sell in {area.name}
            </Link>
          ))}
        </nav>
      </div>

      <a href="https://business.keyzee.co.uk/" target="_blank" rel="noreferrer">
        Keyzee for business
      </a>
      <nav className="footer__policies" aria-label="Legal">
        <Link to="/blog">Blog</Link>
        <Link to="/contact/">Contact Us</Link>
        <Link to="/privacy/">Privacy Policy</Link>
        <Link to="/terms/">Terms of Service</Link>
        <Link to="/cookies/">Cookie Policy</Link>
      </nav>
      <small className="footer__attribution">
        {PRICE_PAID_ATTRIBUTION_LEAD}
        <a href={OGL_LICENCE_URL} target="_blank" rel="license noopener noreferrer">
          {OGL_LICENCE_NAME}
        </a>
        .
      </small>
    </footer>
  )
}

export default Footer
